<template>
  <div v-if="!hasPermission('List Service Queue')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar/>
    <div class="container-xxl">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h3 class="card-title">Filas de Atendimento</h3>
          <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal_service_queue"
                  @click="openCreateModal">
            <i class="bi bi-plus-lg"></i> Nova Fila
          </button>
        </div>
        <div class="card-body">
          <input class="form-control mb-3" v-model="search" placeholder="Pesquisar fila..."/>
          <table class="table table-row-bordered gy-5">
            <thead>
            <tr>
              <th>Nome</th>
              <th>Ativo</th>
              <th>Prioridade</th>
              <th>Próxima Fila</th>
              <th>Terminais</th>
              <th style="text-align:center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="queue in filteredServiceQueues" :key="queue.id_service_queue"
                :class="{ 'table-active': selectedQueue && selectedQueue.id_service_queue === queue.id_service_queue }"
                @click="selectQueue(queue)">
              <td>
                <p>{{ queue.service_queue_name }}</p>
                <p class="badge badge-light-primary">{{ queue.service_queue_type !== 'OT' ? 'Padrão' : '' }}</p>
              </td>
              <td>
                      <span class="badge" :class="queue.active ? 'badge-light-success' : 'badge-light-danger'">
                        {{ queue.active ? 'Sim' : 'Não' }}
                      </span>
              </td>
              <td>{{ queue.priority }}</td>
              <td>{{ queue.next_queue?.service_queue_name || '-' }}</td>
              <td>
                <span v-for="terminal in queue.terminals" :key="terminal.id_terminal"
                      class="badge bg-primary opacity-75 me-1 mb-2">
                  {{ terminal.terminal_name }}
                </span>
              </td>
              <td style="text-align:center">
                <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                        v-if="hasPermission('Update Service Queue')"
                        @click.stop="openEditModal(queue)" data-bs-toggle="modal" data-bs-target="#modal_service_queue"
                        title="Editar">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button class="btn btn-icon btn-bg-light btn-active-color-primary"
                        v-if="queue.service_queue_type === 'OT' && hasPermission('Delete Service Queue')"
                        @click.stop="deleteServiceQueue(queue.id_service_queue)" title="Excluir">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal fade" id="modal_service_queue" tabindex="-1">
        <div class="modal-dialog">
          <form class="modal-content" @submit.prevent="saveServiceQueue">
            <div class="modal-header">
              <h5 class="modal-title">{{ form.id_service_queue ? 'Editar Fila' : 'Nova Fila' }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label">Nome</label>
                <input :disabled="form.service_queue_type !== 'OT'"
                       class="form-control" v-model="form.service_queue_name" required/>
              </div>
              <div class="mb-3">
                <label class="form-label">Prioridade (quanto menor, mais prioritário)</label>
                <input type="number" class="form-control" v-model="form.priority" min="0" max="10" required/>
              </div>
              <div class="mb-3">
                <label class="form-label">Próxima Fila</label>
                <select :disabled="form.service_queue_type !== 'OT'"
                        class="form-select" v-model="form.id_next_queue">
                  <option :value="null">Nenhuma</option>
                  <option v-for="q in serviceQueues" :key="q.id_service_queue" :value="q.id_service_queue">
                    {{ q.service_queue_name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-check-label me-3 mb-2" for="active">
                  Ativar Fila?
                </label>
                <div class="form-check form-switch d-flex align-items-center gap-2 m-0">
                  <input :disabled="form.service_queue_type !== 'OT'"
                         class="form-check-input" type="checkbox" v-model="form.active"
                         role="switch" id="active">
                  <label class="form-check-label m-0">
                    {{ form.active ? 'Sim' : 'Não' }}
                  </label>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Terminal</label>
                <MultiSelect
                    v-model="form.terminals"
                    :options="terminals"
                    optionLabel="terminal_name"
                    optionValue="id_terminal"
                    placeholder="Selecione os terminais"
                    :filter="true"
                    :showClear="true"
                    class="w-100"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/helpers/http'
import MultiSelect from 'primevue/multiselect'
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import Permission from '../../helpers/permission';
import alert from '@/helpers/alert';

export default {
  name: 'ServiceQueueCrud',
  components: {
    MultiSelect,
    Toolbar
  },
  data() {
    return {
      search: '',
      serviceQueues: [],
      terminals: [],
      form: {
        id_service_queue: null,
        service_queue_name: '',
        service_queue_type: '',
        active: true,
        id_place: '',
        priority: 1,
        id_next_queue: null,
        terminals: []
      },
      selectedQueue: null
    }
  },
  computed: {
    filteredServiceQueues() {
      return this.serviceQueues.filter(q =>
          q.service_queue_name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    async loadData() {
      this.serviceQueues = (await http.get(`/places/${this.place.id_place}/service-queues`)).data
      this.terminals = (await http.get(`/places/${this.place.id_place}/terminals`)).data
      this.selectedQueue = null
    },
    selectQueue(queue) {
      this.selectedQueue = queue
    },
    openCreateModal() {
      this.form = {
        id_service_queue: null,
        service_queue_name: '',
        service_queue_type: 'OT',
        active: true,
        id_place: this.place.id_place,
        priority: 10,
        id_next_queue: null,
        terminals: []
      }
    },
    openEditModal(queue) {
      this.form = {
        id_service_queue: queue.id_service_queue,
        service_queue_name: queue.service_queue_name,
        service_queue_type: queue.service_queue_type,
        active: queue.active,
        id_place: queue.id_place,
        priority: queue.priority,
        id_next_queue: queue.id_next_queue,
        terminals: queue.terminals ? queue.terminals.map(t => t.id_terminal) : []
      }
    },
    async saveServiceQueue() {
      if (this.form.priority < 0 || this.form.priority > 10) {
        alert.error('A prioridade deve estar entre 0 e 10.');
        return;
      }
      try {
        if (this.form.id_service_queue) {
          await http.put(`/places/${this.place.id_place}/service-queues/${this.form.id_service_queue}`, this.form)
          alert.toastSuccess('Fila atualizada com sucesso!');
        } else {
          await http.post(`/places/${this.place.id_place}/service-queues`, this.form)
          alert.toastSuccess('Fila criada com sucesso!');
        }
        await this.loadData()
        bootstrap.Modal.getInstance(document.getElementById('modal_service_queue')).hide()
      } catch (e) {
        alert.toastError('Erro ao salvar a fila.');
      }
    },
    async deleteServiceQueue(id) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover a forma de recebimento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await http.delete(`/places/${this.place.id_place}/service-queues/${id}`)
            alert.toastSuccess('Fila excluída com sucesso!');
            await this.loadData()
          } catch (e) {
            alert.toastError('Erro ao excluir a fila.');
          }
      }
      })
    }
  }
}
</script>

<style scoped>
.table-active {
  background: #f0f6ff;
}
</style>